import { Card } from "@/components/Card";
import { Button } from "@/components/generic/Button";
import { formatDateTime } from "@/utils/dates";
import { BellIcon } from "lucide-react";
import { useMemo } from "react";

interface AppointmentReminderToastProps {
  leadName: string;
  callTime: string;
  minutesUntil: number;
  onDismiss: () => void;
  onViewLead: () => void;
}

export function AppointmentReminderToast({
  leadName,
  callTime,
  minutesUntil,
  onDismiss,
  onViewLead,
}: AppointmentReminderToastProps) {
  const timeText = useMemo(() => {
    if (minutesUntil <= 15 && minutesUntil >= 14) {
      return "15 minutter";
    }
    if (minutesUntil <= 1 && minutesUntil >= 0) {
      return "1 minut";
    }
  }, [minutesUntil]);

  return (
    <Card
      theme="none"
      className="text-theme-on-glass min-w-103 rounded-lg bg-[var(--theme-notification-glass)] p-5"
    >
      <div className="flex flex-col">
        <div className="flex items-start gap-3">
          <div className="relative w-fit">
            <div className="bg-theme-gradient-from/25 border-theme-gradient-from absolute inset-0 rounded-full border-[0.5px]" />
            <div className="relative z-10 p-1.5">
              <BellIcon size={18} className="text-theme-primary" />
            </div>
          </div>

          <div className="mt-1 flex flex-col">
            <span className="text-sm leading-5 font-semibold">
              Din opfølgning med {leadName} er om {timeText}
            </span>
            <span className="text-theme-on-background-variant text-sm font-medium">
              I dag kl.{" "}
              {formatDateTime(callTime, { hour: "2-digit", minute: "2-digit" })}
            </span>
          </div>
        </div>

        <div className="flex w-full justify-center gap-x-4 pt-3">
          <Button
            size="sm"
            intent="secondary"
            className="h-8 max-w-fit min-w-27 text-xs"
            onPress={onDismiss}
          >
            <span className="text-xs font-medium">Luk</span>
          </Button>
          <Button
            size="sm"
            className="h-8 max-w-fit min-w-27 text-xs"
            onPress={onViewLead}
          >
            <span className="text-xs font-medium">Vis lead</span>
          </Button>
        </div>
      </div>
    </Card>
  );
}
